import React, { memo } from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import { CommonStyles, Color, CommonProperties } from '../../styles';
import Icon from '../Icon';
import BaseText from '../BaseText';
import ListControl from './ListControl';

const BarItem = ({ label, disabled, icon, ...rest }) => {
  const selectedColor = disabled ? styles.disabled : null;
  return (
    <TouchableOpacity disabled={disabled} style={CommonStyles.centerAlignment} {...rest}>
      <View style={CommonStyles.centerItems}>
        <Icon name={icon} size={24} color={!disabled ? Color.primary : Color.disabled} />
        <BaseText numberOfLines={1} style={[styles.text, selectedColor]}>
          {label}
        </BaseText>
      </View>
    </TouchableOpacity>
  );
};

const Bar = memo(({ style, items = [], onChange }) => {
  return (
    <ListControl
      items={items}
      noShadow
      style={[styles.bar, style]}
      renderItem={(item) => (
        <BarItem
          icon={item.icon}
          disabled={item.disabled}
          label={item.label}
          onPress={() => onChange(item.value)}
        />
      )}
    />
  );
});

const styles = StyleSheet.create({
  bar: {
    justifyContent: 'space-around',
    ...CommonProperties.py3,
  },
  disabled: {
    color: Color.disabled,
  },
  text: {
    color: Color.primary,
    ...CommonProperties.h4,
    ...CommonProperties.mt2,
  },
});

export default Bar;
